<template>
    <div v-if="auth && status" class="issuer">
        <span @click="openModal" class="issuer__btn">Сообщения эмитента</span>
        <a v-if="link" class="issuer__link" :href="link" target="_blank">
            <i title="Страница эмитента" class="fas fa-external-link-alt"></i>
        </a>
        <issuer-modal v-if="isModal" @close="closeModal" :ogrn="ogrn" />
    </div>
</template>

<script>
import issuerModal from '@/components/card/shortResume/issuerMessage/issuerModal.vue'

export default {
    components: {
        issuerModal
    },
    data: () => ({
        isModal: false
    }),
    computed: {
        ogrn() { return this.$store.state.card?.company?.ogrn },
        status() { return this.$store.state.card?.shortResume?.issuer?.status },
        link() { return this.$store.getters['card/shortResume/issuer/link'] }

    },
    methods: {
        openModal() {
            this.isModal = true
            this.$store.dispatch('card/shortResume/issuer/getData', { ogrn: this.ogrn, limit: 25, offset: 0 })
        },
        closeModal() { this.isModal = false }
    },
    mounted() {
        if(auth && (Number(window.company?.okopf) === 12247 || Number(window.company?.okopf) === 12267)) {
            this.$store.dispatch('card/shortResume/issuer/getStatus', this.ogrn)
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.issuer
    display: flex
    gap: 5px
    font-size: 13px
    &__btn
        border: none
        background: none
        padding: 0
        @include pseudo-link
        font-weight: 400 !important
        
    &__link
        @include pseudo-link
</style>